// extracted by mini-css-extract-plugin
export default {"navHeight":"60px","navHeightWithoutPixels":"60","collapseMinHeight":"600","collapseWidthSwitchContainer":"1200","fourContainerCollapseHeight":"730"};